import axios from "@/plugins/axios";

let url = "/api/console/gshop2/collection";

export const collection = {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },

}